<template>
  <!-- Alt şerit: üst çubukla aynı yüzey (20px köşe, 12px kenar boşluğu); görünüm light/style.scss `.iq-footer`. -->
  <footer class="iq-footer">
    <div class="iq-footer__left"><slot name="left"></slot></div>
    <div class="iq-footer__right"><slot name="right"></slot></div>
  </footer>
</template>
<script>
export default {
  name: 'FooterStyle'
}
</script>
